// src/pages/TermsPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Box, 
  Container, 
  Typography, 
  Toolbar,
  Paper
} from '@mui/material';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const TermsPage = () => {
  const { t } = useTranslation('legal');

  const termsBreadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "首頁", "item": "https://rebaz.ai" },
      { "@type": "ListItem", "position": 2, "name": t('terms.title'), "item": "https://rebaz.ai/terms" }
    ]
  };

  return (
    <>
      <SEO
        title={t('terms.title')}
        description={t('terms.description')}
        canonicalUrl="https://rebaz.ai/terms"
        breadcrumb={termsBreadcrumb}
      />
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh'
      }}>
        {/* Header */}
        <PublicHeader />
        <Toolbar />

        {/* Main Content */}
        <Box component="main" sx={{ flexGrow: 1, py: 6, backgroundColor: '#f5f5f5' }}>
          <Container maxWidth="md">
            <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2 }}>
              <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
                {t('terms.title')}
              </Typography>
              
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                {t('terms.lastUpdated')}
              </Typography>

              {/* Section 1: Acceptance of Terms */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.acceptance.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.acceptance.content')}
              </Typography>

              {/* Section 2: Service Description */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.serviceDescription.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.serviceDescription.content')}
              </Typography>

              {/* Section 3: User Accounts */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.userAccounts.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.userAccounts.content')}
              </Typography>

              {/* Section 4: Acceptable Use */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.acceptableUse.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.acceptableUse.content')}
              </Typography>

              {/* Section 5: Intellectual Property */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.intellectualProperty.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.intellectualProperty.content')}
              </Typography>

              {/* Section 6: Payment Terms */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.payment.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.payment.content')}
              </Typography>

              {/* Section 7: Limitation of Liability */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.liability.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.liability.content')}
              </Typography>

              {/* Section 8: Termination */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.termination.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.termination.content')}
              </Typography>

              {/* Section 9: Governing Law */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.governingLaw.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.governingLaw.content')}
              </Typography>

              {/* Section 10: Contact */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('terms.sections.contact.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('terms.sections.contact.content')}
              </Typography>
              <Typography variant="body1">
                Email: service@rebaz.ai
              </Typography>
            </Paper>
          </Container>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
};

export default TermsPage;